var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeCamion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-6 {\n        mask: url(#mask);\n      }\n\n      .cls-7 {\n        filter: url(#luminosity-invert);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3, .cls-5 {\n        fill: #ad974f;\n      }\n\n      .cls-4 {\n        fill: #000;\n        fill-opacity: .6;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    x: -60.4,
    y: -64.4,
    width: 620.7,
    height: 620.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -60.4,
    y: -64.4,
    width: 620.7,
    height: 620.7,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0830767a5d",
    "data-name": "0830767a5d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -60.4,
    y: -64.4,
    width: 620.7,
    height: 620.7
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.4,
    y: 123.9,
    width: 475.9,
    height: 242.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.9,
    y: 124.1,
    width: 320,
    height: 154.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41,
    y: 286.7,
    width: 80,
    height: 79.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 337.5,
    y: 286.7,
    width: 78.6,
    height: 79.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.6,162v125.8l198.6.2c-11.6,9.5-18.9,22.6-18.8,39.9h-197.1c-1.9-66.9-96.7-66.7-98.7-.5-14.2-.1-16.2-3.3-16.3-16.5v-50.2c-.2-22.4-3-7.6,13.6-50.1,17.1-45.3,12.4-41.1,27.8-42.3l91-6.3ZM108.2,236.2l.8-53.4-50.7,3.1c-9.2.6-9.3.7-12.6,11.4l-13,34.6c-4.4,10.6-3.7,13.7,8.2,12.2l67.2-7.9ZM487.5,288.1v28.3c0,0-32.6,11.6-32.6,11.6h-28.7c.1-16.4-6.7-30.2-18.8-39.9h80.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.9,124.2h319.8v152.8H167.9V124.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.9,326.8c0-1.3,0-2.6-.2-3.8-.1-1.3-.3-2.5-.6-3.8-.2-1.3-.6-2.5-.9-3.7-.4-1.2-.8-2.4-1.3-3.6s-1-2.3-1.6-3.5c-.6-1.1-1.3-2.2-2-3.3s-1.5-2.1-2.3-3.1c-.8-1-1.7-1.9-2.6-2.8-.9-.9-1.9-1.8-2.8-2.6-1-.8-2-1.6-3.1-2.3-1.1-.7-2.2-1.4-3.3-2-1.1-.6-2.3-1.1-3.5-1.6-1.2-.5-2.4-.9-3.6-1.3s-2.5-.7-3.7-.9c-1.3-.3-2.5-.4-3.8-.6-1.3-.1-2.5-.2-3.8-.2s-2.5,0-3.8.2c-1.3.1-2.5.3-3.8.6-1.3.2-2.5.6-3.7.9s-2.4.8-3.6,1.3c-1.2.5-2.3,1-3.5,1.6-1.1.6-2.2,1.3-3.3,2-1.1.7-2.1,1.5-3.1,2.3-1,.8-1.9,1.7-2.8,2.6-.9.9-1.8,1.8-2.6,2.8-.8,1-1.6,2-2.3,3.1s-1.4,2.2-2,3.3c-.6,1.1-1.1,2.3-1.6,3.5s-.9,2.4-1.3,3.6c-.4,1.2-.7,2.5-.9,3.7-.2,1.3-.4,2.5-.6,3.8-.1,1.3-.2,2.5-.2,3.8s0,2.6.2,3.8.3,2.5.6,3.8c.2,1.3.6,2.5.9,3.7.4,1.2.8,2.4,1.3,3.6.5,1.2,1,2.3,1.6,3.5s1.3,2.2,2,3.3,1.5,2.1,2.3,3.1c.8,1,1.7,1.9,2.6,2.8s1.8,1.8,2.8,2.6c1,.8,2,1.6,3.1,2.3,1.1.7,2.2,1.4,3.3,2s2.3,1.1,3.5,1.6c1.2.5,2.4.9,3.6,1.3s2.5.7,3.7.9c1.3.3,2.5.4,3.8.6,1.3.1,2.5.2,3.8.2s2.6,0,3.8-.2c1.3-.1,2.5-.3,3.8-.6,1.3-.2,2.5-.6,3.7-.9s2.4-.8,3.6-1.3c1.2-.5,2.3-1,3.5-1.6s2.2-1.3,3.3-2c1.1-.7,2.1-1.5,3.1-2.3,1-.8,1.9-1.7,2.8-2.6s1.8-1.8,2.6-2.8c.8-1,1.6-2,2.3-3.1s1.4-2.2,2-3.3,1.1-2.3,1.6-3.5c.5-1.2.9-2.4,1.3-3.6.4-1.2.7-2.5.9-3.7.2-1.3.4-2.5.6-3.8s.2-2.5.2-3.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M415.7,326.8c0-1.3,0-2.6-.2-3.8-.1-1.3-.3-2.5-.6-3.8-.2-1.3-.6-2.5-.9-3.7-.4-1.2-.8-2.4-1.3-3.6s-1-2.3-1.6-3.5c-.6-1.1-1.3-2.2-2-3.3s-1.5-2.1-2.3-3.1c-.8-1-1.7-1.9-2.6-2.8s-1.8-1.8-2.8-2.6c-1-.8-2-1.6-3.1-2.3-1.1-.7-2.2-1.4-3.3-2-1.1-.6-2.3-1.1-3.5-1.6-1.2-.5-2.4-.9-3.6-1.3s-2.5-.7-3.7-.9c-1.3-.3-2.5-.4-3.8-.6-1.3-.1-2.5-.2-3.8-.2s-2.6,0-3.8.2c-1.3.1-2.5.3-3.8.6-1.3.2-2.5.6-3.7.9s-2.4.8-3.6,1.3c-1.2.5-2.3,1-3.5,1.6-1.1.6-2.2,1.3-3.3,2-1.1.7-2.1,1.5-3.1,2.3-1,.8-1.9,1.7-2.8,2.6-.9.9-1.8,1.8-2.6,2.8-.8,1-1.6,2-2.3,3.1-.7,1.1-1.4,2.2-2,3.3-.6,1.1-1.1,2.3-1.6,3.5-.5,1.2-.9,2.4-1.3,3.6-.4,1.2-.7,2.5-.9,3.7-.2,1.3-.4,2.5-.6,3.8-.1,1.3-.2,2.5-.2,3.8s0,2.6.2,3.8.3,2.5.6,3.8c.3,1.3.6,2.5.9,3.7.4,1.2.8,2.4,1.3,3.6.5,1.2,1,2.3,1.6,3.5s1.3,2.2,2,3.3c.7,1.1,1.5,2.1,2.3,3.1.8,1,1.7,1.9,2.6,2.8.9.9,1.8,1.8,2.8,2.6,1,.8,2,1.6,3.1,2.3,1.1.7,2.2,1.4,3.3,2s2.3,1.1,3.5,1.6c1.2.5,2.4.9,3.6,1.3s2.5.7,3.7.9c1.3.3,2.5.4,3.8.6,1.3.1,2.5.2,3.8.2s2.5,0,3.8-.2c1.3-.1,2.5-.3,3.8-.6,1.3-.2,2.5-.6,3.7-.9s2.4-.8,3.6-1.3c1.2-.5,2.3-1,3.5-1.6,1.1-.6,2.2-1.3,3.3-2,1.1-.7,2.1-1.5,3.1-2.3,1-.8,1.9-1.7,2.8-2.6.9-.9,1.8-1.8,2.6-2.8.8-1,1.6-2,2.3-3.1s1.4-2.2,2-3.3c.6-1.1,1.1-2.3,1.6-3.5.5-1.2.9-2.4,1.3-3.6.4-1.2.7-2.5.9-3.7.2-1.3.4-2.5.6-3.8.1-1.3.2-2.5.2-3.8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCamion);
export default __webpack_public_path__ + "static/media/Icone-camion.5937f71ea3262dc7be30a8c013c8e7c7.svg";
export { ForwardRef as ReactComponent };